// Configuração da API
const isLocalDevelopment = process.env.NODE_ENV === 'development';
export const API_URL =
  process.env.REACT_APP_API_URL ||
  (isLocalDevelopment ? 'http://localhost:8000' : 'https://leadssearch-api-1.onrender.com');

// Outras configurações globais podem ser adicionadas aqui
export const APP_NAME = 'MedPrime Benefícios';

export const WHATSAPP_NUMBER = '5511965115307';
